// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"44":"cdf0c19a","683":"aab25b22"}[chunkId] + ".css";
};